
import Header from './Header.vue';
import Footer from './Footer.vue';
import {
	getCurrentInstance,
	onMounted,
	ref,
} from 'vue';
import { useRouter } from 'vue-router';
import log from '@/global/log';
export default {
	components: {
		Header,
		Footer,
	},
	emits: ['scroll'],
	name: 'Layout',
	props: {
		isDark: {
			type: Boolean,
			required: false,
			default: false,
		},
		hasFooter: {
			type: Boolean,
			required: false,
			default: true,
		},
		topPadding: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	setup() {
		const instance = getCurrentInstance();
		const emit = instance!.emit;
		let gnbShow = ref(true);
		const router = useRouter();

		function scroll(event: Event) {
			const element = event.target as HTMLElement;
			// ** 현재 스크롤위치
			const scrollPosition = element.scrollTop;
			//** 스크롤 영역 높이 */
			const scrollHeight = element.scrollHeight;

			// log(
			// 	'scroll position ' + scrollPosition
			// );
			// log(
			// 	'scroll scrollHeight' + scrollHeight
			// );
			// log(
			// 	'scroll einnerHeight ' +
			// 		window.innerHeight
			// );
			emit(
				'scroll',
				scrollPosition,
				scrollHeight
			);

			//메인 gnb아이콘 show
			if (
				router.currentRoute.value.path == '/' &&
				scrollPosition > window.innerHeight
			) {
				gnbShow.value = true;
			} else if (
				router.currentRoute.value.path == '/' &&
				scrollPosition <= window.innerHeight
			) {
				gnbShow.value = false;
			}
		}

		onMounted(() => {
			if (router.currentRoute.value.path == '/') {
				gnbShow.value = false;
			}
		});
		return {
			scroll,
			gnbShow,
		};
	},
};
